export default "__VITE_ASSET__00104483__"